// eslint-disable-next-line internal-rules/no-restricted-async-data-context-imports -- to be removed by .claude/plans/extract-data-fetching-from-shared-components.md, which deletes this file
import { createPrefetchableAsyncDataContext } from '#src/app/shared/contexts/asyncData';

import { getMembershipAwarenessFormData } from './api';

/** @knip-ignore */
export const {
	Context: MembershipAwarenessFormDataContext,
	Provider: MembershipAwarenessFormDataContextProvider,
	useContext: useMembershipAwarenessFormData,
	useAsyncData: useMembershipAwarenessFormDataFromApi,
	prefetchAsyncData: prefetchMembershipAwarenessFormDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'MembershipAwarenessFormDataContext',
	dataProperty: 'formData',
	hasUserData: true,
	getData: getMembershipAwarenessFormData,
});
